module.exports = __webpack_public_path__ + "static/strategy-6-7705c2814e4bc6a966f7d3e313b35644.jpg";